module.exports = __webpack_public_path__ + "img/construction-pathway.b6b191dc.jpg";